import { AvatarButtonCore, AvatarButtonCoreProps } from './AvatarButtonCore';

const AvatarButton = AvatarButtonCore;
export type AvatarButtonProps = AvatarButtonCoreProps;

export default AvatarButton;
